"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var FormFooter = (0, mobx_react_1.observer)(function (_a) {
    var store = _a.store;
    return (react_1.default.createElement("div", { className: "estimateForm-FormFooter" },
        store.abTestFormsVariant !== 'after' &&
            react_1.default.createElement("button", { disabled: !store.isNextButtonEnabled, onClick: store.handleClickNextButton, className: store.nextButtonClassNames }, "\u6B21\u3078"),
        store.description &&
            react_1.default.createElement("div", { className: "estimateForm-FormFooter_Text" }, store.description),
        store.showsPrevButton &&
            react_1.default.createElement("button", { onClick: store.handleClickPrevButton, className: "estimateForm-FormFooter_PrevButton" }, "\u623B\u308B")));
});
exports.default = FormFooter;
